import React, { FC, forwardRef } from 'react';
import styles from './CustomInput.module.scss';

interface CustomInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: boolean;
  helperText?: string;
  type?: string;
  multiline?: boolean;
  rows?: number;
  required?: boolean;
  id?: string;
  name?: string;
  autoComplete?: string;
}

const CustomInput: FC<CustomInputProps> = forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  CustomInputProps
>(({ 
  label, 
  value, 
  onChange, 
  onBlur, 
  error, 
  helperText, 
  type = 'text',
  multiline = false,
  rows = 1,
  required = false,
  id,
  name,
  autoComplete = 'off',
  ...props 
}, ref) => {
  const inputId = id || `input-${label.replace(/\s+/g, '-').toLowerCase()}`;
  
  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <label 
          className={error ? styles.errorLabel : ''} 
          htmlFor={inputId}
        >
          {required && '* '}{label}
        </label>
        
        {multiline ? (
          <textarea
            ref={ref as React.Ref<HTMLTextAreaElement>}
            className={error ? styles.errorInput : ''}
            onChange={onChange}
            onBlur={onBlur}
            id={inputId}
            name={name}
            value={value}
            rows={rows}
            required={required}
            {...props}
          />
        ) : (
          <input
            ref={ref as React.Ref<HTMLInputElement>}
            className={error ? styles.errorInput : ''}
            onChange={onChange}
            onBlur={onBlur}
            id={inputId}
            name={name}
            type={type}
            value={value}
            required={required}
            autoComplete={autoComplete}
            {...props}
          />
        )}
        
        {error && helperText && (
          <p className={styles.errorMessage}>
            {helperText}
          </p>
        )}
      </div>
    </div>
  );
});

CustomInput.displayName = 'CustomInput';

export default CustomInput;